import { render, staticRenderFns } from "./index.vue?vue&type=template&id=5b315cd3&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b315cd3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/actions-runner/_work/treasurenet-tnservices-producerPlatform-fe/treasurenet-tnservices-producerPlatform-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b315cd3')) {
      api.createRecord('5b315cd3', component.options)
    } else {
      api.reload('5b315cd3', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=5b315cd3&scoped=true", function () {
      api.rerender('5b315cd3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/authentication/approve/index.vue"
export default component.exports